import { useParams } from 'next/navigation';

export const useLocale = () => {
  const { locale } = useParams();
  if (locale?.includes('de-')) {
    return { locale, isGeniusDomain: false };
  }
  if (typeof window !== 'undefined' && window.location.host.includes('genius.tv')) {
    const localeDomain = window.location.host.split('.').shift() || '';
    return { locale: `${locale}-${localeDomain.toUpperCase()}`, isGeniusDomain: true };
  }
  return { locale, isGeniusDomain: false };
};
